let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8gQKz"), load("1D6DH"), load("6zfzy"), load("ipxYo")]).then(() => parcelRequire('6h9cg'));